import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { reduxForm, formValueSelector } from 'redux-form';
import { withRouter } from 'react-router';
import { withState } from 'recompose';
import { getBrandCurrency } from '../../brands/reducers';
import SubscriptionForm from '../components/SubscriptionForm';

const FORM = 'subscriptionForm';

const form = reduxForm({
  form: FORM,
  enableReinitialize: true,
});

const selector = formValueSelector(FORM);

export default compose(
  withRouter,
  connect((state, props) => {
    let initialValues = { price: 0, quantity: 0, enabled: false };
    if (props.subscription) {
      const planPrice = props.subscription.subscriptionPlanPrice || {};
      initialValues = {
        subscriptionPlanId: props.subscription.subscriptionPlanId,
        enabled: props.subscription.enabled,
        price: planPrice.price || 0,
        quantity: planPrice.quantity || 0,
        indyCustomAppAddon: props.subscription.indyCustomAppAddon,
      };
    }

    return {
      initialValues,
      hasSubscription: Boolean(props.subscription),
      chargeSubscription: selector(state, 'enabled'),
      currency: getBrandCurrency(state, props.params.id),
      indyCustomAppAddon: selector(state, 'indyCustomAppAddon'),
    };
  }),
  form,
  withState('canEditIndyCustomAppAddon', '_setCanEditIndyCustomAppAddon', props => (!props.subscription || props.indyCustomAppAddon)),
)(SubscriptionForm);
